import { TemplateType } from '@pia/pia.shared';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'templateType',
})
export class TemplateTypePipe implements PipeTransform {
  transform(value: string) {
    return TemplateType[value];
  }
}
